import type { ImageProps } from '@builder4/shared/components/Image';
import { useNode } from '@craftjs/core';
import { CanvasImage } from '../../canvas/CanvasImage/CanvasImage';
import { useMixpanel } from '@/hooks/useMixpanel';
import { EVENT, SOURCE, PROPERTY } from '@/analytics/mixpanel';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';
import { useImageManager } from '@/hooks/useImageManager';
import type { AssetResponse } from '@lp/lib-asset-api';
import { MAX_IMAGE_UPLOAD_HEIGHT } from '@/utils/constants';

const NodeImagePlaceholder = () => {
  const track = useMixpanel();
  const { openImageManager } = useImageManager();

  const {
    actions: { setProp },
    isActive,
    displayName,
  } = useNode((node) => ({
    isActive: node.events.selected,
    displayName: node.data.displayName,
  }));

  const { setBPProp } = useBreakpointAwareProp(displayName);

  const handleSelectImage = (image: AssetResponse) => {
    const cappedHeight = Math.min(image.height, MAX_IMAGE_UPLOAD_HEIGHT);
    setProp((props: Partial<ImageProps>) => {
      setBPProp(props, 'id', image._meta.id);
      setBPProp(props, 'src', image.fileUri);
      setBPProp(props, 'alt', image.metadata.altText);
      setBPProp(props, 'height', `${cappedHeight}px`);
    });

    track(EVENT.IMAGE_ADDED, {
      [PROPERTY.SOURCE]: SOURCE.LIBRARY,
    });
  };

  const handleClick = () => {
    openImageManager({ onSelectImage: handleSelectImage });
  };

  return (
    <div style={{ height: '100%', width: '100%' }} onClick={handleClick}>
      <CanvasImage type={isActive ? 'active' : 'default'} />
    </div>
  );
};

export default NodeImagePlaceholder;
